export const selectFilter = state => state.filter;

export const selectToken = state => state.token.token;
